/**
 * This object is the initial state of the store.
 */

export default {};
